import React from 'react';
import DocPage from './DocPage';

const sections = [
  {
    id: 'overview',
    title: 'Overview',
    body: (
      <p>
        Blends Pet Solutions Private Ltd ("PetCart") uses cookies and similar technologies on this
        website. Some are essential for the site to work. Analytics tools load only if you accept
        them through our cookie banner.
      </p>
    ),
  },
  {
    id: 'essential',
    title: 'Essential cookies',
    body: (
      <p>
        Needed for basic site function — for example remembering your cookie preference and keeping
        pages working as you navigate. These do not require consent.
      </p>
    ),
  },
  {
    id: 'analytics',
    title: 'Analytics cookies and tools',
    body: (
      <>
        <p>
          If you accept analytics, we may use:
        </p>
        <ul className="mt-2 list-disc space-y-1 pl-5">
          <li>
            <strong>Google Analytics</strong> — to understand aggregate traffic, popular pages, and
            how visitors find us.
          </li>
          <li>
            <strong>Google Tag Manager / Google Ads</strong> — to measure advertising performance
            and attribute conversions (for example, form submissions) when you arrive from ads.
          </li>
        </ul>
        <p className="mt-3">
          These tools can set cookies or use local storage and may process identifiers that can be
          linked to your browser or device. You can decline via the banner; analytics will not load.
        </p>
      </>
    ),
  },
  {
    id: 'manage',
    title: 'Managing preferences',
    body: (
      <p>
        Use Accept or Decline on our cookie banner when it appears. To change a previous choice,
        clear cookies and site data for this website in your browser, then reload the page — the
        banner will appear again. You can also control cookies in your browser settings.
      </p>
    ),
  },
  {
    id: 'questions',
    title: 'Questions',
    body: (
      <p>
        Write to{' '}
        <a href="mailto:shekhar@petcart.com" className="text-primary font-medium hover:underline">
          shekhar@petcart.com
        </a>{' '}
        and we'll get back to you. See also our Privacy Policy for how we handle personal data.
      </p>
    ),
  },
];

const CookiePolicy = () => (
  <DocPage title="Cookie Policy" lastUpdated="July 2026" sections={sections} />
);

export default CookiePolicy;
